<template>
  <div class="tabs">
    <div class="tab-titles">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="tab-title"
        :class="{ active: tab.name === activeTab }"
        @click="setActiveTab(tab.name)"
      >
        {{ tab.label }}
      </div>
    </div>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, provide, defineProps } from 'vue';

interface Tab {
  name: string;
  label: string;
}

const props = defineProps<{
  initialTab?: string;
  tabs: Tab[];
}>();

const activeTab = ref(props.initialTab || props.tabs[0]?.name || '');

const setActiveTab = (tabName: string) => {
  activeTab.value = tabName;
};

provide('activeTab', activeTab);
provide('setActiveTab', setActiveTab);

const tabs = props.tabs;
</script>

<style scoped>
.tabs {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
}

.tab-titles {
  display: flex;
  background-color: #f5f5f5;
}

.tab-title {
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: background-color 0.3s, border-bottom 0.3s;
}

.tab-title.active {
  background-color: white;
  border-bottom: 2px solid #409EFF; /* Active tab border color */
}

.tab-content {
  padding: 20px;
}
</style>
